import request from '@/utils/request'

export const getRoleList = ({ page, size, keywords: name }) => {
  return request({
    url: `/upms/role/${page}/${size}`,
    params: {
      name
    }
  })
}

export const postRoleEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/role',
    data
  })
}

export const putRoleAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/role',
    data
  })
}

export const getRoleDetail = ({ id }) => {
  return request({
    url: `/upms/role/${id}`
  })
}

export const deleteRoleDel = ({ id }) => {
  return request({
    method: 'delete',
    url: `/upms/role/${id}`
  })
}

export const delRoleList = (data) => {
  return request({
    method: 'delete',
    url: '/upms/role/all',
    data
  })
}

export const putRoleSource = (data) => {
  return request({
    method: 'put',
    url: '/upms/roleresource',
    data
  })
}

export const getRoleSource = (roleId) => {
  return request({
    url: `/upms/roleresource/${roleId}`
  })
}
